
// region JS Imports

// region External Modules
import $ from "jquery"
import Promise from "plugins/bluebird/index"
// endregion External Modules

// Private Modules
import DataRetriever from "app/data_retriever"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
import TransactionDataChart from "components/chart/transaction_data_chart"
import {
  TransactionCountsGroupedByMonth,
} from "components/chart/transaction_data_chart"
import {
  init as neighbourhood_follow_button_init,
} from "concepts/neighbourhoods/neighbourhood_follow_button/index"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


let chart_promise: Promise<any> = new Promise((_resolve) => {
  // Will never call resolve or reject
})
let $highcharts_canvas = $()

const update_analytics_header_tiles = (data: {
  transactions_last_month_price_value: string,
  transactions_last_month_price_growth: string,
  transactions_last_month_volume_value: string,
  transactions_last_month_volume_growth: string,
  currency_unit_for_display: string,
}) => {

  const $last_month_price = $(".cell--neighbourhoods--transaction--market-data-overview__tiles-container__content.last_month_price").find(
                              ".cell--neighbourhoods--transaction--market-data-overview__tiles-container__value")
  const last_month_price = parseInt(data.transactions_last_month_price_value, 10).toLocaleString()
  $last_month_price.text(`${data.currency_unit_for_display}${last_month_price}`)

  const $last_month_price_change = $(".cell--neighbourhoods--transaction--market-data-overview__tiles-container__title-change.last_month_price_change")
  const last_month_price_change = parseInt(data.transactions_last_month_price_growth, 10)

  if (last_month_price_change >= 0){
    $last_month_price_change.removeClass("negative-growth")
    $last_month_price_change.text(`+${last_month_price_change}%`)
  } else {
    $last_month_price_change.addClass("negative-growth")
    $last_month_price_change.text(`${last_month_price_change}%`)
  }

  const $last_month_volume = $(".cell--neighbourhoods--transaction--market-data-overview__tiles-container__content.last_month_volume")
  const last_month_volume = parseInt(data.transactions_last_month_volume_value, 10).toLocaleString()
  $last_month_volume.text(last_month_volume)

  const $last_month_volume_change = $(".cell--neighbourhoods--transaction--market-data-overview__tiles-container__title-change.last_month_volume_change")
  const last_month_volume_change = parseInt(data.transactions_last_month_volume_growth, 10)

  if (last_month_volume_change >= 0){
    $last_month_volume_change.removeClass("negative-growth")
    $last_month_volume_change.text(`+${last_month_volume_change}%`)
  } else {
    $last_month_volume_change.addClass("negative-growth")
    $last_month_volume_change.text(`${last_month_volume_change}%`)
  }
}
const create_highchart = (data: {
  transaction_counts_grouped_by_months: TransactionCountsGroupedByMonth[],
  transactions_price_spacious: number[],
  transactions_last_month_price_value: string,
  transactions_last_month_price_growth: string,
  transactions_last_month_volume_value: string,
  transactions_last_month_volume_growth: string,
  currency_unit_for_display: string,
  currency_unit: string | undefined,
}) => {
  update_analytics_header_tiles(data)

  if ($highcharts_canvas.length > 0 ) {
    data.currency_unit = data.currency_unit_for_display
    chart_promise = TransactionDataChart.create(
      $highcharts_canvas,
      data
    )
  }
}

const update_highchart = (
  data: {
    transaction_counts_grouped_by_months: TransactionCountsGroupedByMonth[],
    transactions_price_spacious: number[],
  },
  duration_selected: any) => {
  if ($highcharts_canvas.length > 0 ) {
    return TransactionDataChart.update(
      chart_promise,
      data,
      duration_selected
    )
  }
}

const init = (): Promise<any> => {
  return new Promise((resolve) => {
    neighbourhood_follow_button_init()

    // Query START
    const $section_container = $(".page-container")
    // This section is city specific, so could be absent
    if ($section_container.length === 0) {
      resolve()
      return
    }

    $highcharts_canvas = $(".cell--neighbourhoods--transaction--market-data-overview__highcharts-canvas")

    const $current_city_id = DataRetriever.get("current-city-id")
    if (["string", "number"].indexOf(typeof $current_city_id) === -1) { return }
    if ($current_city_id.length === 0) { return }

    const $current_neighbourhood_id = DataRetriever.get("neighbourhood-id")
    if ($current_neighbourhood_id === 0) { return }

    const $empty_graph_if_not_enough_data = $(".cell--neighbourhoods--transaction--market-data-overview__main-container--not-available")
    if ($empty_graph_if_not_enough_data.length > 0) { return }

    const ajax_call_for_updating_highcharts_graph = ((duration_selected: any) => {
      Promise.resolve(
        import(
          "plugins/js-routes"
        )
      )
      .then((Routes) => {



        q_ajax_3({
          url:    Routes.api_web_app_real_estate_transaction_statistics_neighbourhood_index_path({
            neighbourhood_id: $current_neighbourhood_id,
            duration: duration_selected,
            is_rental: false,
          }),
          method:   "GET",
          dataType: "json",
        })
        .then(({data}) => update_highchart(data.data, duration_selected))
        .catch(({response}) => {

          // We noticed for some users the failure of ajax call with a returned status code 0
          // This failure might be due to a number of reason, external to our Rails app
          // For more information about the different reasons:
          // - http://stackoverflow.com/a/14507670/838346
          if (response.status === 0) {
            return
          }
          // Otherwise throw an error

          // Baiduspider-render issue
          if (response.status === 40) {
            return
          }
          if (response.status === 423) {
            return
          }

          // How to get HTTP status code from jQuery XHR obj:
          // - https://api.jquery.com/jQuery.ajax/#jqXHR
          // - https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/status
          throw new Error(
            "#ajax_call_for_updating_highcharts_graph failed in " +
            "App.Pages.Neighbourhoods.Show.Components.TransactionAnalytics, " +
            `HTTP status code: ${response.status} ` +
            `with given textStatus message: ${response.statusText}`
          )
        })
        .done()
      })
      .done()
    })

    const ajax_call_for_creating_highcharts_graph = ((current_neighbourhood_id: number) => {
      Promise.resolve(
        import(
          "plugins/js-routes"
        )
      )
      .then((Routes) => {
        q_ajax_3({
          url:    Routes.api_web_app_real_estate_transaction_statistics_neighbourhood_index_path({
            neighbourhood_id: current_neighbourhood_id,
            duration: 12,
            is_rental: false,
          }),
          method:   "GET",
          dataType: "json",
        })
        .then(({data}) => {
          if (data.data == null) {
            throw new Error(
              "data.data is null in " +
              "App.Pages.Neighbourhoods.Show.Components.TransactionAnalytics, " +
              `HTTP status code: ${status} ` +
              `data: ${data} `
            )
          }

          return create_highchart(data.data)
        })
        .catch(({response}) => {

          // We noticed for some users the failure of ajax call with a returned status code 0
          // This failure might be due to a number of reason, external to our Rails app
          // For more information about the different reasons:
          // - http://stackoverflow.com/a/14507670/838346
          if (response.status === 0) {
            return
          }
          // Otherwise throw an error

          // Baiduspider-render issue
          if (response.status === 40) {
            return
          }
          if (response.status === 423) {
            return
          }

          // How to get HTTP status code from jQuery XHR obj:
          // - https://api.jquery.com/jQuery.ajax/#jqXHR
          // - https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/status
          throw new Error(
            "#ajax_call_for_creating_highcharts_graph failed in " +
            "App.Pages.Neighbourhoods.Show.Components.TransactionAnalytics, " +
            `HTTP status code: ${response.status} ` +
            `with given textStatus message: ${response.statusText}`
          )
        })
      })
      .done()
    })

    ajax_call_for_creating_highcharts_graph($current_neighbourhood_id)

    const $all_duration_list_items = $( ".cell--neighbourhoods--transaction--market-data-overview__highcharts-sidebar__duration_data_box" )

    $all_duration_list_items.on("click", ({currentTarget}) => {
      const $clicked_duration_el = $(currentTarget)
      const duration_selected = $clicked_duration_el.data("duration")

      $all_duration_list_items.removeClass("with-data--selected")
      $clicked_duration_el.addClass("with-data--selected")

      if ($highcharts_canvas.length > 0) {
        chart_promise.then((chart) => chart.showLoading())
      }

      return ajax_call_for_updating_highcharts_graph(duration_selected)
    })


    resolve()
  })
}


export default {
  init: init,
}
